import { field, readContract, writeContractAndWait } from "../viem";
import { approveToken, getTokenAllowance } from ".";
import MafiaProfileTicketAbi from "../../abis/MafiaProfile.json";
import config from "../../config/config";
import { PROFILE_PRICE_IN_MAFIA } from "../../constants/const";
import { TravelInfo } from "../../types/Contract/Profile/TravelInfo";
import { SwapToken } from "../../types/Contract/SwapToken";

const address = config.profileAddress;
const abi = MafiaProfileTicketAbi;

export const hasChainProfile = async (account: string): Promise<boolean> => Boolean(await readContract({
  address,
  abi,
  functionName: "hasProfile",
  args: [account],
}));

export const createProfile = async (
  name: string,
  account: string,
  referrer: string,
  gender: number,
  country: string,
  avatarNumber: number
) => {
  return writeContractAndWait({
    address,
    abi,
    functionName: "createProfile",
    args: [name, 0, referrer, gender, country, avatarNumber],
    account,
  });
};

export const approveTicketContract = async (account: string) => {
  const profilePrice = PROFILE_PRICE_IN_MAFIA;
  const tokenAddress = config.mafiaAddress;
  const contractAddress = config.profileAddress;

  const allowance = await getTokenAllowance(
    tokenAddress,
    account,
    contractAddress
  );

  if (Number(allowance) < profilePrice) {
    await approveToken(tokenAddress, profilePrice, contractAddress, account);
  }
};

export const userTicketId = async (account: string) => {
  const ticketId = await readContract({
    address,
    abi,
    functionName: "userTicketId",
    args: [account],
  });

  return ticketId;
};

export const boughtTicket = async (account: string) => {
  const bought: boolean = await readContract({
    address,
    abi,
    functionName: "boughtTicket",
    args: [account],
  });

  return bought;
};

export const getSwapTokens = async () => {
  const swapTokenInfo: [SwapToken[], number[]] = await readContract({
    address,
    abi,
    functionName: "getSwapTokens",
  });

  return swapTokenInfo;
};

export const travel = async (
  destinationCity: number,
  travelType: number,
  itemId: number,
  account: string
) => {
  const tx = await writeContractAndWait({
    address,
    abi,
    functionName: "travel",
    args: [destinationCity, travelType, itemId],
    account,
    gasMultiplier: 5,
  });

  return tx;
};

export const getUserTravelInfo = async (
  account: string,
  signature: string,
  signMsg: string
) => {
  const travelInfo: TravelInfo = await readContract({
    address,
    abi,
    functionName: "getUserTravelInfo",
    args: [account, JSON.stringify(signMsg), signature],
  });

  return {
    travelType: Number(field(travelInfo, "travelType", 0)),
    travelUntil: Number(field(travelInfo, "travelUntil", 4)),
    itemId: Number(field(travelInfo, "itemId", 5)),
  } as TravelInfo;
};
